import * as React from "react";
import { useState, useEffect } from "react";
// import ViewSummaryWeekly from "../../day-event/View-summaryWeekly";
import "../../PopUp/PopUP.css";
import AddClassMaterial from "../buttons/AddClassMaterial";
import JoinNowbtn from "../buttons/JoinNowbtn";
import ViewSummaryBtn from "../buttons/ViewSummaryBtn";
import moment from "moment";
import axios from "../../../../axios";
import { SubStdSelContext } from "../../../../SubStdSelContext";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import { Tooltip } from "@mui/material";

/**
 * sets how to display day based events on the sj schedule day view component
 * @param {*} param0
 * @returns
 */
const general_role = localStorage.getItem("general_role");
const jsonRole_Geinformation = JSON.parse(general_role);
const mapStateToProps = (state) => ({
  inc: state.redres,
  dec: state.redres1,
  ovr: state.redres2,
});
const SciencePopUp = ({ event, inc, dec, refresh }) => {
  const [summary, setSummary] = useState(false);
  const [activity, setActivity] = useState([]);
  const [homework, setHomework] = useState([]);
  const [preRead, setPreRead] = useState([]);
  const [assessment, setAssessment] = useState([]);
  const [editfunction, setEditFunction] = useState(false);
  console.log(assessment, "checking");

  const { secSelectedOption, stdSelectedOption, teacherDCM } =
    React.useContext(SubStdSelContext);
  console.log(secSelectedOption, stdSelectedOption);
  const currentTime = new Date();

  // determines if event is after currently happening based on current time
  const isHappened = currentTime.getTime() > event?.EndTime?.getTime();

  // determines if event is currently happening based on current time
  const isEventHappening =
    currentTime.getTime() >= event?.StartTime?.getTime() &&
    currentTime.getTime() <= event?.EndTime?.getTime();

  // determines if event is before currently happening based on current time
  const isUpcoming = currentTime.getTime() < event?.StartTime?.getTime();

  const onJoinNowClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const timeDiff = (timeStart, timeEnd) => {
    var time1 = timeStart;
    var time2 = timeEnd;
    // Convert the time strings to Date objects
    var date1 = new Date(time1);
    var date2 = new Date(time2);

    // Calculate the difference in milliseconds between the two times
    var diffInMs = date2.getTime() - date1.getTime();

    // Convert the difference in milliseconds to minutes, assuming 1 minute = 60000 ms
    var diffInMins = diffInMs / 60000;
    return diffInMins;
  };
  const handleSupplementDetails = async () => {
    event?.Events?.forEach((obj) => {
      if (obj.name === "activity") {
        axios
          .get(`api/v1/homework/activity/getById/${obj.value}`)
          .then((res) => {
            res && setActivity(res.data.data);
          });
      }
      if (obj.name === "pre_read") {
        axios
          .get(`api/v1/homework/preRead/getById/${obj.value}`)
          .then((res) => {
            res && setPreRead(res.data.data);
          });
      }
      if (obj.name === "assessment") {
        axios.get(`api/v1/assessment/get/${obj.value}`).then((res) => {
          res && setAssessment(res.data.data);
        });
      }
      if (obj.name === "homework") {
        axios.get(`api/v1/homework/get/${obj.value}`).then((res) => {
          res && setHomework(res.data.data);
        });
      }
    });
  };
  useEffect(() => {
    handleSupplementDetails();
  }, []);
  useEffect(() => {
    if (teacherDCM === "option3") {
      jsonRole_Geinformation.forEach((element) => {
        if (element.standard_id.id === inc.id) {
          if (element.section_id.id === dec.id) {
            element.subjects_id.forEach((element) => {
              if (element.name === event.Subject) {
                setEditFunction(true);
              } else {
                setEditFunction(false);
              }
            });
          }
        }
      });
    } else {
      setEditFunction(true);
    }
  }, [event]);
  // const navigateToRoute = (path) => {
  //   return <Link to={path} />;
  // };

  function shortenParagraph(text, maxLength) {
    if (text?.length <= maxLength) {
      return text;
    }
    return text?.slice(0, maxLength)?.trim() + "...";
  }
  // console.log(moment(event.StartTime).format("ddd, hA"))
  return event ? (
    <>
      <div onClick={onJoinNowClick} className="quick-info-content">
        <div className="headingPoPUP">
          <div>
            <div className="sub_pop_head">
              {isHappened && "PREVIOUS SESSION"}
              {isEventHappening && "LECTURE SESSION "}
              {isUpcoming && "UPCOMING SESSION "}
            </div>
            <div className="sub_pop_head">
              {
                <Tooltip
                  title={event?.Subject}
                  arrow
                  placement="top"
                  enterDelay={200}
                  leaveDelay={100}
                >
                  <div>{shortenParagraph(event?.Subject, 15)}</div>
                </Tooltip>
              }
            </div>
            <div className="sub_pop_Subhead">
              {
                <Tooltip
                  title={event?.TeacherName}
                  arrow
                  placement="bottom"
                  enterDelay={200}
                  leaveDelay={100}
                >
                  <div>{shortenParagraph(event?.TeacherName, 15)}</div>
                </Tooltip>
              }
            </div>
            <div className="sub_pop_Subhead">
              {
                <Tooltip
                  title={event?.LectureName}
                  arrow
                  placement="bottom"
                  enterDelay={200}
                  leaveDelay={100}
                >
                  <div>{shortenParagraph(event?.LectureName, 15)}</div>
                </Tooltip>
              }
            </div>
          </div>
          <div>
            <div className="sub_pop_head">
              {moment(event?.StartTime).format(" Do MMM YY , dddd")}
            </div>
            <div className="sub_pop_head d-flex justify-content-end">
              {moment(event?.StartTime).format(" h:mm A")}&nbsp;-{" "}
              {moment(event?.EndTime).format(" h:mm A")}
            </div>
            {/* <div className='sub_pop_head' >{moment(event.EndTime).format(" h:mm a")}</div> */}
            <div className="sub_pop_Subhead d-flex justify-content-end">
              {timeDiff(event?.StartTime, event?.EndTime)}Min
            </div>
          </div>
        </div>
        {/* Div for description */}
        <div className="brder">{}</div>
        <div class="bg-white">
          <div className="brder">
            {event.Events.some((item) => item.name === "activity") && (
              <div className="headingPoPUP_detail">
                <div
                  className="col-4"
                  onClick={localStorage.setItem("from", "DCM")}
                >
                  <NavLink
                    to={`/PublishedQListActvity`}
                    state={{ publishedActivity_id: activity.id }}
                  >
                    <img
                      className="popIcon"
                      src="/DCM-img/activity.svg"
                      alt=""
                    />
                  </NavLink>
                  <div className="icon_pop_title_Activity">Activity</div>
                </div>
                <div>
                  <div className="sub_pop_head">
                    {
                      <Tooltip
                        title={activity?.name}
                        arrow
                        placement="bottom"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <div>{shortenParagraph(activity?.name, 20)}</div>
                      </Tooltip>
                    }
                  </div>
                  <div className="blwhead">
                    {
                      <Tooltip
                        title={activity?.description}
                        arrow
                        placement="bottom"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <div>{shortenParagraph(activity?.description, 30)}</div>
                      </Tooltip>
                    }
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div class=" card-header_new bg-white">
          <div className="brder">
            {event.Events.some((item) => item.name === "pre_read") && (
              <div className="headingPoPUP_detail">
                <div
                  className="col-4"
                  onClick={localStorage.setItem("from", "DCM")}
                >
                  <NavLink
                    to={`/PublishedQListPreRead`}
                    state={{ publishPre_id: preRead.id }}
                  >
                    <img className="popIcon" src="images/preRead.svg" alt="" />
                  </NavLink>
                  <div className="icon_pop_title_preRead">Pre-read</div>
                </div>
                <div>
                  <div className="sub_pop_head">
                    {
                      <Tooltip
                        title={preRead?.name}
                        arrow
                        placement="bottom"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <div>{shortenParagraph(preRead?.name, 25)}</div>
                      </Tooltip>
                    }
                  </div>
                  <div className="blwhead">
                    {
                      <Tooltip
                        title={preRead?.description}
                        arrow
                        placement="bottom"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <div>{shortenParagraph(preRead?.description, 30)}</div>
                      </Tooltip>
                    }
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div class=" card-header_new bg-white">
          <div className="brder">
            {event.Events.some((item) => item.name === "homework") && (
              <div className="headingPoPUP_detail">
                <div
                  className="col-4"
                  onClick={localStorage.setItem("from", "DCM")}
                >
                  {/* Here removed id from url */}
                  <NavLink
                    to={`/PublishedQListHW`}
                    state={{ homework_id: homework.id }}
                  >
                    <img
                      className="popIcon"
                      src="/DCM-img/homework.svg"
                      alt=""
                    />
                  </NavLink>
                  <div className="icon_pop_title">Homework</div>
                </div>
                <div>
                  {/* <div className="sub_pop_head">{homework.name}</div> */}
                  <div className="sub_pop_head">
                    {
                      <Tooltip
                        title={homework?.name}
                        arrow
                        placement="bottom"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <div>{shortenParagraph(homework?.name, 25)}</div>
                      </Tooltip>
                    }
                  </div>
                  {
                    <Tooltip
                      title={homework?.description}
                      arrow
                      placement="bottom"
                      enterDelay={200}
                      leaveDelay={100}
                    >
                      <div>{shortenParagraph(homework?.description, 30)}</div>
                    </Tooltip>
                  }
                </div>
              </div>
            )}
          </div>
        </div>
        <div class=" card-header_new bg-white">
          <div>
            {event.Events.some((item) => item.name === "assessment") && (
              <div className="headingPoPUP_detail">
                <div
                  className="col-4"
                  onClick={localStorage.setItem("from", "DCM")}
                >
                  <NavLink
                    to="/PublishedQList"
                    state={{ assessmentId: assessment?.id }}
                  >
                    <img
                      className="popIcon"
                      src="/DCM-img/assessment.svg"
                      alt=""
                    />
                  </NavLink>
                  <div className="icon_pop_title">Assessment</div>
                </div>
                <div>
                  <div className="sub_pop_head">
                    {
                      <Tooltip
                        title={assessment?.name}
                        arrow
                        placement="bottom"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <div>{shortenParagraph(assessment?.name, 25)}</div>
                      </Tooltip>
                    }
                  </div>
                  <div className="blwhead">
                    {
                      <Tooltip
                        title={assessment?.description}
                        arrow
                        placement="bottom"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <div>
                          {shortenParagraph(assessment?.description, 30)}
                        </div>
                      </Tooltip>
                    }
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div>
          {isHappened && (
            <ViewSummaryBtn
              event={event}
              setSummary1={setSummary}
              refresh={refresh}
              assessment={assessment}
            />
          )}
          {/* {summary && <SummaryUpdated CloseSummaryShowToday={()=>{setSummary(false)}} data={event} open={()=>{open1()}}/>} */}
          {isEventHappening &&
            event.Events.some((item) => item.name === "bbb_lecture") && (
              <JoinNowbtn event={event} />
            )}
          {editfunction && isUpcoming && <AddClassMaterial event={event} />}
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};
export default connect(mapStateToProps)(SciencePopUp);
